var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('v-layout',{attrs:{"fill-height":"","align-center":"","justify-center":"","ma-0":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',{staticClass:"noWrap"},[_vm._v(" "+_vm._s(_vm.propertyName || _vm.getId)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }